import React from "react";
import { Plus } from "lucide-react";
import { useCart, formatEUR } from "../../contexts/CartContext";
import { useLanguage } from "../../i18n/LanguageContext";
import { toast } from "sonner";

export default function ProductCard({ product }) {
  const { addItem, openCart } = useCart();
  const { t } = useLanguage();

  const handleAdd = () => {
    addItem(product, 1);
    toast.success(`${product.name} · ${t.tienda.added}`, {
      action: {
        label: t.cart.checkout,
        onClick: () => openCart(),
      },
    });
  };

  return (
    <article
      data-testid={`product-card-${product.id}`}
      className="group relative bg-white border border-[#E5E0D8] flex flex-col"
    >
      <div className="aspect-[4/5] overflow-hidden bg-[#F2EDE3]">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
      </div>
      <div className="p-5 md:p-6 flex flex-col gap-3 grow">
        <div>
          <div className="text-[0.6rem] uppercase tracking-[0.2em] text-[#8B1E0F] font-semibold mb-2">
            {product.unit}
          </div>
          <h3 className="font-serif-display text-xl md:text-2xl text-[#1A1A1A] leading-tight">
            {product.name}
          </h3>
          {product.description && (
            <p className="mt-2 text-xs text-[#5C5C5C] leading-relaxed">
              {product.description}
            </p>
          )}
        </div>
        <div className="mt-auto pt-4 flex items-center justify-between gap-3 border-t border-[#E5E0D8]">
          <div
            className="font-mono text-lg font-semibold text-[#1A1A1A]"
            data-testid={`product-price-${product.id}`}
          >
            {formatEUR(product.price_cents)}
          </div>
          <button
            onClick={handleAdd}
            data-testid={`product-add-${product.id}`}
            className="inline-flex items-center gap-1.5 bg-[#8B1E0F] hover:bg-[#6A160A] text-white px-4 py-2.5 text-[0.65rem] tracking-[0.2em] uppercase font-semibold transition-colors"
          >
            <Plus className="h-3.5 w-3.5" />
            {t.tienda.addToCart}
          </button>
        </div>
      </div>
    </article>
  );
}
